module.exports = __webpack_public_path__ + "static/media/login-gradient-bg.acbecf84.png";